import axios from 'axios'
import { logSearchError } from '../../listings-client/util/clientLogger'
import { generatePhoneBookCall } from './queries/generatePhoneBookCall'

export const generatePhoneBookNumber = phoneBookInput => {
  if (Object.keys(phoneBookInput).length > 0) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/pws/v0/pcln-graph/',
        method: 'post',
        data: {
          query: generatePhoneBookCall,
          variables: { request: phoneBookInput },
        },
        headers: {
          'apollographql-client-name': 'm-fly-search',
        },
      })
        .then(response => resolve(response?.data?.data?.phoneBookAirEntry))
        .catch(error => {
          logSearchError('phoneBookCall', error)
          reject(error)
        })
    })
  } else {
    return Promise.resolve('phoneBookInput empty')
  }
}
